import React, {useEffect, useState} from "react";
import SVG from "react-inlinesvg";
import { Modal, Form, Col } from "react-bootstrap";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../../../../../../../../../_metronic/_helpers";
import * as handlers from "../../../../../../../../_redux/selected-user/selectedUserHandlers"
import { useParams } from "react-router-dom";
import cogoToast from "cogo-toast";
import { useAddPaymentMutation } from "../../../../../../../../../../../redux/apiSlice";
import { ucFirst } from "../../../../../../../../../../util/Helpers";

const AddPaymentModal = ({showAddPaymentModal, onHide, currency, partner, refreshPayments}) => {

    const dispatch = useDispatch();
    const {userId, accountId} = useParams();
    const [type, setType] = useState("DEPOSIT")
    const [validated, setValidated] = useState(false);
    const [ addPayment, { isLoading, isSuccess }] = useAddPaymentMutation();
    const profile = useSelector(({selectedUser}) => selectedUser.data?.profile, shallowEqual);

    // Create Payment for User
    const handleSubmitWithdrawal = e => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;
        if (form.checkValidity() === true) {
            const formData = new FormData(form);
            const data = {...Object.fromEntries(formData.entries()), userId, accountId};
            data.meta = {...profile.basic, currency}
            addPayment(data);
        }
        setValidated(true);
    }

    /* Close Modal on Success */
    useEffect(() => {
        if (isSuccess) {
            cogoToast.success("Payment Added Successfully"); 
            onHide();
            if (refreshPayments) {
                refreshPayments();
            } else {
                dispatch(handlers.fetchUserAccountDetails(userId, accountId));
            }
        }
    }, [isSuccess, onHide, refreshPayments, dispatch, accountId, userId]);

  return (
    <Modal
        show={showAddPaymentModal}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false}
        onExited={_ => setValidated(false)}
      >
      
        <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmitWithdrawal}
        >
            <Modal.Header >
            <Modal.Title id="contained-modal-title-vcenter">
                
                <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                    <SVG
                        title=""
                        src={toAbsoluteUrl("/media/svg/icons/Shopping/Gift.svg")}
                    />
                </span>
                Add New Payment Record
            </Modal.Title>
            <button type="button" className="close" onClick={onHide}>
                <span aria-hidden="true" className="d-block">×</span>
                <span className="sr-only">Close</span>
            </button>
            </Modal.Header>
            <Modal.Body 
                className="px-10 py-2"
            >
                <div className="row mt-5">
                    <div className="col-lg-4 pr-5">
                        <h6 className="mb-0 pt-3">Account</h6>
                    </div>                   
                    <Form.Group as={Col} controlId="partner">
                        <Form.Control
                            type="text"
                            value={ucFirst(partner)}
                            readOnly={true}
                        />
                    </Form.Group>
                </div>
                <div className="row">
                    <div className="col-lg-4 pr-5">
                        <h6 className="mb-0 pt-3">User ID</h6>
                    </div>                   
                    <Form.Group as={Col} controlId="userId">
                        <Form.Control
                            required
                            type="text"
                            name="userId"
                            value={userId}
                            readOnly={true}
                        />
                    </Form.Group>
                </div>
                <div className="row">
                    <div className="col-lg-4 pr-5">
                        <h6 className="mb-0 pt-3">Account ID</h6>
                    </div>                   
                    <Form.Group as={Col} controlId="accountId">
                        <Form.Control
                            required
                            type="text"
                            name="accountId"
                            value={accountId}
                            readOnly={true}
                        />
                    </Form.Group>
                </div>
                <div className="row">
                    <div className="col-lg-4 pr-5">
                        <h6 className="mb-0 pt-3">Payment Type</h6>
                    </div>                   
                    <Form.Group as={Col} controlId="type">
                        <Form.Control
                            required
                            as="select"
                            className="mr-sm-2"
                            custom
                            name="type"
                            onChange={e => setType(e.currentTarget.value)}
                        >
                            <option value="DEPOSIT">Deposit</option>
                            <option value="WITHDRAW">Withdraw</option>
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                            Select Payment Type
                        </Form.Control.Feedback>
                    </Form.Group>
                </div>

                <div className="row">
                    <div className="col-lg-4 pr-5">
                        <h6 className="mb-0 pt-3">Reference</h6>
                    </div>                   
                    <Form.Group as={Col} controlId="bankRef">
                        <Form.Control
                            required
                            type="text"
                            name="idempotencyKey"
                            autoComplete="off"
                            minLength={4}
                        />
                        <Form.Control.Feedback type="invalid">
                            Enter Valid Idempotency Key or Transaction Reference
                        </Form.Control.Feedback>
                    </Form.Group>
                </div>
                
                <div className="row">
                    <div className="col-lg-4 pr-5">
                        <h6 className="mb-0 pt-3">Amount in {currency}</h6>
                    </div>                   
                    <Form.Group as={Col} controlId="amount">
                        <Form.Control
                            required
                            type="text"
                            name="amount"
                            pattern="^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$"
                            autoComplete="off"
                        />
                        <Form.Control.Feedback type="invalid">
                            Enter Valid Amount
                        </Form.Control.Feedback>
                    </Form.Group>
                </div>
                {
                    type === "DEPOSIT" ?
                        <div className="form-check form-check-inline pl-2 py-3 mb-5">
                            <input 
                                type="checkbox" 
                                name="instantDeposit" 
                                value="true"
                                className="form-check-input"
                                id="instantDeposit"
                            />
                            <label 
                                htmlFor="instantDeposit" 
                                className="form-check-label pl-3 h5 text-dark">
                            Instant Deposit <small>(Fund get credited to user Trading Account Immediately)</small>
                            </label>
                        </div>
                        :
                        <p className="py-3">
                            <strong>NOTE:</strong> This action will debit the user trading account immediately
                        </p>
                }
                
            </Modal.Body>
            <Modal.Footer className="justify-content-centerx">
                <button
                    type="button"
                    onClick={onHide}
                    disabled={isLoading}
                    className="btn btn-light btn-elevate px-4"
                >
                    Cancel
                </button>
                <> </>
                <button
                    type="submit"
                    disabled={isLoading}
                    className="btn btn-primary btn-elevate px-4 ml-4"
                >
                    Add Payment
                </button>
            </Modal.Footer>
        </Form>
      </Modal>

        );
}

export default AddPaymentModal;